import { useTranslation } from "react-i18next";
import { Collapse } from "../../../../components/motion";

const ChildSeatSelection = ({
    cart,
    isUsingChildSeat,
    clickChildSeat,
    incrementChildSeat,
    decrementChildSeat,
    toddlerS,
    childS,
    infantS,
}) => {
    const { t } = useTranslation();
    return (
        <div className="tw:mb-5">
            <div className="tw:!mb-2 tw:flex tw:justify-between tw:items-center">
                <p className="tw:!m-0 tw:!font-[400] tw:!text-[15px] noto">
                    {t("BookingConfirmation.ChildSeat.Title")}
                </p>
                <p className="tw:!m-0 tw:!font-[500] tw:!text-[16px] noto">
                    + 1,100{`${t("JPY.JP")}${t("JPY")}`}
                </p>
            </div>

            {cart && cart.bookingInfo.map((item, index) => {
                return (
                    <div
                        className={`mb-3 ${!isUsingChildSeat ? `d-none` : ``}`}
                        key={index}
                    >
                        <div className="tw:p-0">
                            {cart.bookingInfo.length > 1 && (
                                <div className="tw:mb-2">
                                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                                        <p className="tw:!m-0 tw:!font-[400] tw:!text-[13px] tw:!opacity-50 noto">
                                            {`${t(
                                                "BookingConfirmation.ChildSeat.NumberCar.Title"
                                            )} #${index + 1}: ${t(
                                                item.vehicleTypeName.replace(/ /g, ".")
                                            )}`}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/3 tw:md:flex-none">
                                <div
                                    className={`tw:!border tw:!border-[#D9D9D9] tw:rounded-[0.375rem] tw:h-full `}
                                >
                                    <div className="tw:!flex tw:gap-1 tw:!p-3 tw:justify-between tw:items-center tw:h-full">
                                        <div>
                                            <label
                                                className={`tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] `}
                                            >
                                                {t("BookingConfirmation.ChildSeat.InfantSize.Title")}
                                            </label>
                                            <p
                                                className="tw:!mb-0 tw:!text-[13px] tw:!text-[#8D8D8D]"
                                            >
                                                {t("BookingConfirmation.ChildSeat.InfantSize.Desc")}
                                            </p>
                                        </div>
                                        <div>
                                            <div className="tw:flex tw:justify-center tw:gap-4">
                                                <button
                                                    type="button"
                                                    className={`tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-circle tw:flex tw:items-center tw:justify-center ${cart.bookingInfo[index].pax.find(item => item.paxtype === "Baby").paxcount === 0 ||
                                                            cart.bookingInfo[index].childSeat[0].childSeatCount === 0
                                                            ? "btn-outline-disabled"
                                                            : "btn-outline-dark-2"
                                                        }`}
                                                    disabled={cart.bookingInfo[index].pax.find(item => item.paxtype === "Baby").paxcount === 0 || cart.bookingInfo[index].childSeat[0].childSeatCount === 0}
                                                    onClick={() => decrementChildSeat("infant", index)}
                                                >
                                                    <i className="bi bi-dash tw:flex tw:items-center tw:justify-center"></i>
                                                </button>
                                                <div className="tw:flex tw:items-center">
                                                    {infantS[index]}
                                                </div>
                                                <button
                                                    type="button"
                                                    className={`btn btn-circle d-flex align-items-center justify-content-center 
                                                            ${cart.bookingInfo[index].pax.find(item => item.paxtype === "Baby").paxcount === cart.bookingInfo[index].childSeat[0].childSeatCount
                                                            ? `btn-outline-disabled`
                                                            : `btn-outline-dark-2`
                                                        }`}
                                                    disabled={cart.bookingInfo[index].pax.find(item => item.paxtype === "Baby").paxcount == cart.bookingInfo[index].childSeat[0].childSeatCount}
                                                    onClick={() =>
                                                        incrementChildSeat("infant", index)
                                                    }
                                                >
                                                    <i className="bi bi-plus tw:flex tw:items-center tw:justify-center"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/3 tw:md:flex-none tw:mt-2 tw:md:mt-0">
                                <div
                                    className={`tw:!border tw:!border-[#D9D9D9] tw:rounded-[0.375rem] tw:h-full `}
                                >
                                    <div className="tw:!flex tw:gap-1 tw:!p-3 tw:justify-between tw:items-center tw:h-full">
                                        <div>
                                            <label
                                                className={`tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] `}
                                            >
                                                {t("BookingConfirmation.ChildSeat.ToddlerSize.Title")}
                                            </label>
                                            <p
                                                className="tw:!mb-0 tw:!text-[13px] tw:!text-[#8D8D8D]"
                                            >
                                                {t("BookingConfirmation.ChildSeat.ToddlerSize.Desc")}
                                            </p>
                                        </div>
                                        <div>
                                            <div className="tw:flex tw:justify-center tw:gap-4">
                                                <button
                                                    type="button"
                                                    className={`tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-circle tw:flex tw:items-center tw:justify-center ${cart.bookingInfo[index].pax.find(item => item.paxtype === "Toddler").paxcount === 0 ||
                                                            cart.bookingInfo[index].childSeat[1].childSeatCount === 0
                                                            ? "btn-outline-disabled"
                                                            : "btn-outline-dark-2"
                                                        }`}
                                                    disabled={cart.bookingInfo[index].pax.find(item => item.paxtype === "Toddler").paxcount === 0 || cart.bookingInfo[index].childSeat[1].childSeatCount === 0}
                                                    onClick={() => decrementChildSeat("toddler", index)}
                                                >
                                                    <i className="bi bi-dash tw:flex tw:items-center tw:justify-center"></i>
                                                </button>
                                                <div className="tw:flex tw:items-center">
                                                    {toddlerS[index]}
                                                </div>
                                                <button
                                                    type="button"
                                                    className={`btn btn-circle d-flex align-items-center justify-content-center 
                                                            ${cart.bookingInfo[index].pax.find(item => item.paxtype === "Toddler").paxcount === cart.bookingInfo[index].childSeat[1].childSeatCount
                                                            ? `btn-outline-disabled`
                                                            : `btn-outline-dark-2`
                                                        }`}
                                                    disabled={cart.bookingInfo[index].pax.find(item => item.paxtype === "Toddler").paxcount == cart.bookingInfo[index].childSeat[1].childSeatCount}
                                                    onClick={() =>
                                                        incrementChildSeat("toddler", index)
                                                    }
                                                >
                                                    <i className="bi bi-plus tw:flex tw:items-center tw:justify-center"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-1/3 tw:md:flex-none tw:mt-2 tw:md:mt-0">
                                <div
                                    className={`tw:!border tw:!border-[#D9D9D9] tw:rounded-[0.375rem] tw:h-full `}
                                >
                                    <div className="tw:!flex tw:gap-1 tw:!p-3 tw:justify-between tw:items-center tw:h-full">
                                        <div>
                                            <label
                                                className={`tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] `}
                                            >
                                                {t("BookingConfirmation.ChildSeat.ChildSize.Title")}
                                            </label>
                                            <p
                                                className="tw:!mb-0 tw:!text-[13px] tw:!text-[#8D8D8D]"
                                            >
                                                {t("BookingConfirmation.ChildSeat.ChildSize.Desc")}
                                            </p>
                                        </div>
                                        <div>
                                            <div className="tw:flex tw:justify-center tw:gap-4">
                                                <button
                                                    type="button"
                                                    className={`tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-circle tw:flex tw:items-center tw:justify-center ${cart.bookingInfo[index].pax.find(item => item.paxtype === "Child").paxcount === 0 ||
                                                            cart.bookingInfo[index].childSeat[2].childSeatCount === 0
                                                            ? "btn-outline-disabled"
                                                            : "btn-outline-dark-2"
                                                        }`}
                                                    disabled={cart.bookingInfo[index].pax.find(item => item.paxtype === "Child").paxcount === 0 || cart.bookingInfo[index].childSeat[2].childSeatCount === 0}
                                                    onClick={() => decrementChildSeat("child", index)}
                                                >
                                                    <i className="bi bi-dash tw:flex tw:items-center tw:justify-center"></i>
                                                </button>
                                                <div className="tw:flex tw:items-center">
                                                    {childS[index]}
                                                </div>
                                                <button
                                                    type="button"
                                                    className={`btn btn-circle d-flex align-items-center justify-content-center 
                                            ${cart.bookingInfo[index].pax.find(item => item.paxtype === "Child").paxcount === cart.bookingInfo[index].childSeat[2].childSeatCount
                                                            ? `btn-outline-disabled`
                                                            : `btn-outline-dark-2`
                                                        }`}
                                                    disabled={cart.bookingInfo[index].pax.find(item => item.paxtype === "Child").paxcount == cart.bookingInfo[index].childSeat[2].childSeatCount}
                                                    onClick={() =>
                                                        incrementChildSeat("child", index)
                                                    }
                                                >
                                                    <i className="bi bi-plus tw:flex tw:items-center tw:justify-center"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

            <Collapse isOpen={isUsingChildSeat}>
                <div className="tw:!bg-[#F9F9F9] tw:!rounded tw:!p-3">
                    <p
                        className="tw:!text-[14px] tw:!m-0 tw:!text-[#4E4E4E]"
                        dangerouslySetInnerHTML={{
                            __html: t("BookingConfirmation.ChildSeat.Note"),
                        }}
                    ></p>
                </div>
            </Collapse>
        </div>
    );
};

export default ChildSeatSelection;